import { render, staticRenderFns } from "./RankingProdutos.vue?vue&type=template&id=5a6dc1d6"
import script from "./RankingProdutos.vue?vue&type=script&lang=js"
export * from "./RankingProdutos.vue?vue&type=script&lang=js"
import style0 from "./RankingProdutos.vue?vue&type=style&index=0&id=5a6dc1d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports